import { animated, useSpring } from '@react-spring/web';

interface BarProps {
    centerX: number;
    y: number;
    barHeight: number;
    width: number;
}

export const Bar = ({ centerX, y, barHeight, width }: BarProps) => {
    const barX = centerX - width / 2;

    const spring = useSpring({
        to: { y, height: barHeight },
        config: { tension: 170, friction: 26 }
    });

    return (
        <animated.rect
            x={barX}
            width={width}
            fill="#208FA1"
            opacity={0.9}
            y={spring.y}
            height={spring.height}
        />
    );
};
